import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { Link } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'
import './ContractDetail.scss'
import { RoleStr } from '../Commons/Utils'

class ContractDetail extends Component {
    constructor(props) {
        super(props)

        this.state = {
            contract: null,
            sendPop: null,
            completePop: null,
            status: 'READY',
            deletePop: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    clickSendbtn = () => {
        this.setState({ sendPop: true })
    }

    closePop = () => {
        this.setState({ sendPop: null })
    }

    clickCompletebtn = () => {
        this.setState({ completePop: true })
    }

    closeCompletePop = () => {
        this.setState({ completePop: null })
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
                this.loadContract()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadContract = () => {
        axios
            .get(`${BACKEND_HOST}/contract-bills/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ contract: res.data, status: res.data.status })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    confirmBill = () => {
        axios
            .post(
                `${BACKEND_HOST}/contract-bills/${this.props.match.params.id}/remit`,
                {},
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                console.log(res.data)
                this.setState({ status: 'REMIT' })
                alert('입금 확인 요청을 보냈습니다.')
                this.closeCompletePop()
            })
            .catch((err) => {
                console.log(err)
                alert('입금 확인 요청에 실패하였습니다.')
                this.closeCompletePop()
            })
    }

    Comma = (num) => {
        if (typeof num === 'number') {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
            return ''
        }
    }

    paymentBoxList = () => {
        const List = this.state.contract.items.map((items, i) => {
            let title = items.title
            if (items.remark && items.remark != '') {
                title += ' (' + items.remark + ')'
            }
            return (
                <div className="payment_item" key={i}>
                    {/* <p className="payment_buget">예산 {this.Comma(items.budget.totalAmount)}원</p> */}
                    <div className="payment_content_wrap">
                        <p className="payment_title">{title}</p>
                        <p className="payment_price ">
                            <span>{this.Comma(items.amount)}</span>원
                        </p>
                    </div>
                    {/* <div className="payment_buget">{items.remark}</div> */}
                </div>
            )
        })
        return List
    }

    renderFiles = (files) => {
        const List = files.map((item, index) => {
            return (
                <a href={item.url} download className="download_file" key={index}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <path
                            fill="none"
                            fillRule="evenodd"
                            stroke="#A2A7AE"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.3"
                            d="M12.9 6.632l-5.484 5.643a3.512 3.512 0 0 1-5.067 0C.95 10.835.95 8.502 2.35 7.062L7.834 1.42a2.341 2.341 0 0 1 3.377 0c.933.96.933 2.515 0 3.475l-5.49 5.642a1.17 1.17 0 0 1-1.689 0 1.254 1.254 0 0 1 0-1.737L9.1 3.593"
                        />
                    </svg>

                    {item.filename}
                </a>
            )
        })

        return List
    }

    render() {
        if (this.state.contract) {
            //날짜 변환
            const newDate2 = new Date(this.state.contract.createdAt)
            const newYear2 = newDate2.getFullYear()
            const week2 = new Array('일', '월', '화', '수', '목', '금', '토')
            const newDayName2 = week2[newDate2.getDay()]

            let newMonth2 = newDate2.getMonth() + 1
            if (newMonth2 < 10) {
                newMonth2 = '0' + newMonth2
            }
            let newDay2 = newDate2.getDate()
            if (newDay2 < 10) {
                newDay2 = '0' + newDay2
            }
            let newHours2 = newDate2.getHours()
            if (newHours2 < 10) {
                newHours2 = '0' + newHours2
            }
            let newMinutes2 = newDate2.getMinutes()
            if (newMinutes2 < 10) {
                newMinutes2 = '0' + newMinutes2
            }

            let totalAmount = 0
            this.state.contract.items.forEach((item) => {
                totalAmount += item.amount
            })

            return (
                <div className="contract_detail_wrap common_detail">
                    <div className="section">
                        <div className="sub_section1">
                            <div className="total_price_wrap">
                                <p className="total_title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#000"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1.2">
                                            <path d="M1 14V1h15v13M1 14c0 2.21 2.015 4 4.5 4s4.5-1.79 4.5-4M16 18a4 4 0 0 0 4-4M10 14h10M16 18H6M5 5.65h6.922M5 9.65h6.922" />
                                        </g>
                                    </svg>
                                    {this.state.contract.title}
                                </p>
                                <p className="total_price">
                                    총 <span>{this.Comma(totalAmount)}</span> 원
                                </p>
                            </div>
                        </div>

                        <div className="sub_section2">
                            <div className="text_wrap write_text_wrap">
                                <div className="title">작성자</div>
                                <div className="content">
                                    {this.state.contract.writer.company.name} {this.state.contract.writer.name}
                                </div>
                                <ul className="write_date">
                                    <li>
                                        {newYear2}.{newMonth2}.{newDay2} ({newDayName2})
                                    </li>
                                    <li className="line" />
                                    <li>
                                        {newHours2}:{newMinutes2}
                                    </li>
                                </ul>
                            </div>

                            <div className="text_wrap">
                                <div className="title">청구내역</div>
                                {this.paymentBoxList()}
                            </div>

                            {this.state.contract.content !== '' && (
                                <div className="text_wrap">
                                    <div className="title">내용</div>
                                    <div className="content">{this.state.contract.content}</div>
                                </div>
                            )}

                            {this.state.contract.files.length !== 0 && (
                                <div className="text_wrap">
                                    <div className="content">{this.renderFiles(this.state.contract.files)}</div>
                                </div>
                            )}

                            {this.state.status === 'CHECKED_REMIT' && (
                                <div className="noti_wrap">
                                    <p className="content">
                                        {this.state.contract.writer.name}은(는) 본 청구에 대한 입금을 확인하였습니다.{' '}
                                    </p>
                                </div>
                            )}

                            {this.state.status === 'REMIT_REJECT' && (
                                <div className="noti_wrap">
                                    <p className="content">
                                        {this.state.contract.receiver.name}은(는) 본 청구에 대한 입금을 거절하였습니다.{' '}
                                    </p>
                                </div>
                            )}

                            {this.state.status === 'REMIT' && (
                                <div className="noti_wrap">
                                    <p className="content">
                                        {this.state.contract.writer.name}이(가) 입금 확인하는 중입니다.{' '}
                                    </p>
                                </div>
                            )}

                            {this.state.completePop && (
                                <div className="alret_pop2_bg">
                                    <div className="alret_pop2_wrap">
                                        <p className="h1_text">본 청구에 대한 송금을 완료하셨습니까?</p>
                                        {/* <p>
                                            '네'선택시 본 건은 <span>입금확인</span>이됩니다.
                                        </p> */}
                                        <div className="btn btn1" onClick={this.closeCompletePop}>
                                            아니오
                                        </div>
                                        <div className="btn btn2" onClick={this.confirmBill}>
                                            네
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.user._id === this.state.contract.receiver._id &&
                                (this.state.status === 'SENT' || this.state.status === 'IN_PROGRESS') && (
                                    <div className="btn_wrap">
                                        <div className="full_btn_pc" onClick={this.clickCompletebtn}>
                                            송금 완료 하기
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                    <Link to={'/budget/bills/'}>
                        <div className="list_btn common_wrap">
                            목록
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8">
                                <g
                                    fill="none"
                                    fillRule="evenodd"
                                    stroke="#6D7075"
                                    strokeLinecap="round"
                                    strokeWidth="1.2">
                                    <path d="M.674 1H9.32M.674 4.06h6.277M.674 7.06h8.65" />
                                </g>
                            </svg>
                        </div>
                    </Link>
                </div>
            )
        }
        return <div />
    }
}

export default withCookies(ContractDetail)



// WEBPACK FOOTER //
// ./Src/Components/Contract/BillDetail.js